export default function decimalSymbolByLocale(intl) {
  const formatter = new Intl.NumberFormat(intl.primaryLocale);
  const parts = formatter.formatToParts(123.45);
  const decimalSymbol = parts.find((p) => {
    return p.type === 'decimal';
  }).value;

  return decimalSymbol;
}
